export default __webpack_public_path__ + "static/media/010-lieutenant.1441d076.png";